<template lang="pug">
  #likes-container.grid-scroll-more(v-scrolled-to-end="fetchMore")
    PageHeader(headerText="Likes" :sortOptions="sortOptions" @sortBy="setSortOrder")
    GridDisplay(:entities="interests")
</template>

<script>
import { mapGetters } from 'vuex'
import fetchAndSort from '@/mixins/fetchAndSort'

export default {
  mixins: [fetchAndSort],
  props: {},

  data() {
    return {
      fetchType: 'interests/fetch',
      sortOrder: 'recent',
      sortOptions: ['recent', 'most liked'],
    }
  },

  channels: {
    InterestsChannel: {
      connected() {},
      rejected() {},
      received(data) {
        if (this.sortOrder == 'recent') {
          this.$store.commit('interests/ADD_OR_UPDATE', data)
        } else {
          this.$store.commit('interests/UPDATE', data)
        }
      },
      disconnected() {},
    },
  },

  computed: {
    ...mapGetters({
      sortBy: 'interests/sortBy',
    }),
    interests,
  },

  watch: {},

  async created() {
    await this.fetchRecords()
  },

  mounted() {
    this.$cable.subscribe({ channel: 'InterestsChannel' })
  },

  methods: {},

  components: {
    GridDisplay: require('@/components/GridDisplay').default,
    PageHeader: require('@/components/PageHeader').default,
  },
}

/* Computed ---------------------------------------------------- */
function interests() {
  return this.sortBy(this.sortOrder)
}
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
